var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 457,
    viewBox: "0 0 614 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M614 150C614 319.551 476.551 457 307 457C137.449 457 0 319.551 0 150C0 -19.5514 137.449 -157 307 -157C476.551 -157 614 -19.5514 614 150ZM154.164 150C154.164 234.409 222.591 302.836 307 302.836C391.409 302.836 459.836 234.409 459.836 150C459.836 65.591 391.409 -2.83603 307 -2.83603C222.591 -2.83603 154.164 65.591 154.164 150Z",
    fill: "#197FFF",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse3);
export default __webpack_public_path__ + "static/media/Ellipse3.663f63ad76aad2c384fa4b58bab85f18.svg";
export { ForwardRef as ReactComponent };